import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['submit'];

  static values = {
    requireInputs: Boolean,
    trimTexts: { type: Boolean, default: false },
  };

  enableSubmit() {
    if (this.requireInputsValue) {
      const { form } = this.submitTarget;
      this.changeDisabledStatus(
        !allRequiredFieldsFilled(form, this.trimTextsValue),
      );
    } else {
      this.changeDisabledStatus(false);
    }
  }

  disableSubmit() {
    this.changeDisabledStatus(true);
  }

  changeDisabledStatus(disabled) {
    this.submitTargets.forEach((target) => {
      target.disabled = disabled;
    });
  }
}

const allRequiredFieldsFilled = (form, trimTexts) => {
  const requiredFields = form.querySelectorAll('[required]');
  return Array.from(requiredFields).every((field) => {
    if (field.type === 'checkbox') {
      return field.checked;
    }
    if (trimTexts) {
      return field.value && field.value.trim().length > 0;
    } else {
      return field.value;
    }
  });
};
